export default __webpack_public_path__ + "static/media/974.cffbfe2c.png";